module.exports = new __parcel__URL__("Logo-LinkedIn.a9ca821d.svg").toString();